<template>
  <div class="personlist-main">
    <div class="search">
      <img src="../../assets/image/search.png" class="searchicon" />
      <input type="text" class="searchlist" id="searchinput" :placeholder="lan.c_search" @input="searchList" />
      <img
        src="../../assets/image/closesearch.png"
        class="close"
        v-show="searchShow"
        @click="closeSearch"
      />
    </div>

    <ul class="search-box" v-show="this.searchShow">
      <li
        v-for="(item,index) in rong.searchList"
        :key="index+'A'"
        v-show="item.recvType==='PERSON'"
        @click="searchperson(item)"
      >{{item.recvId}}</li>
      <li
        v-for="(item,index) in rong.searchList"
        :key="index+'B'"
        v-show="item.recvType==='GROUP'"
        @click="searchgroup(item)"
      >{{item.name}}</li>
    </ul>

    <div class="list" v-show="!this.searchShow">
      <div class="single-chat">
        <div class="chat-title" @click="singleSHOW">
          <img src="../../assets/image/message.png" class="chatimg" />
          <span>{{lan.c_s_chat}}</span>
          <img src="../../assets/image/down.png" :class="turn ? 'turn downimg':'downimg'" />
        </div>
        <ul v-show="singleshow">
          <li
            v-for="(item,index) in personalList.slice(0,singleLength)"
            :key="index+'C'"
            :class="rong.activeIndex == index ?'active personalli':'personalli'"
            @click="showHistory(item,index)"
          >{{item.recvId}}</li>
          <span
            class="singleALL"
            @click="allsingle(personalList.length)"
            v-show="singleLength==5"
          >{{lan.c_showall}}({{personalList.length}})</span>
          <span
            class="singleALL"
            v-show="singleLength>5"
            @click="allclose"
          >{{lan.c_hide}}({{personalList.length}})</span>
        </ul>
      </div>
      <div class="group-chat">
        <div class="chat-title" @click="groupSHOW">
          <img src="../../assets/image/interactive.png" class="chatimg" />
          <span>{{lan.c_g_chat}}</span>
          <img src="../../assets/image/down.png" :class="groupturn ? 'turn downimg':'downimg'" />
        </div>
        <ul v-show="groupshow">
          <li
            v-for="(item,index) in groupList.slice(0,groupLength)"
            :key="index+'D'"
            :class="rong.activeGroupIndex == index ? 'active groupli':'groupli'"
            @click="groupHistory(item,index)"
          >{{item.name}}</li>
          <span
            class="groupALL"
            v-show="groupLength>5"
            @click="closegroup"
          >{{lan.c_hide}}({{personalList.length}})</span>
          <span
            class="groupALL"
            @click="allgroup(groupList.length)"
            v-show="groupLength ==5"
          >{{lan.c_showall}}({{groupList.length}})</span>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import Tool from "../../assets/commonjs/tool";
export default {
  name: "personlist",
  data() {
    return {
      singleUrlList: [],
      groupUrlList: [],
      active: false,
      searchShow: false,
      singleLength: 5,
      groupLength: 5,
      turn: false,
      groupturn: false,
      singleshow: true,
      groupshow: true
    };
  },
  computed: {
    ...mapState(["login", "rong", "headurl"]),
    ...mapGetters({
      personalList: "rong/personalList",
      groupList: "rong/groupList",
      lan: "common/lan"
    })
  },

  methods: {
    ...mapMutations({
      getList: "rong/getPersonList",
      showHistory_s_r: "rong/showHistory_s_r",
      showHistory_g_r: "rong/showHistory_g_r",
      getrecvID: "rong/getrecvID",
      getType: "rong/getType",
      initNum: "rong/initNum",
      showSearchList: "rong/showSearchList",
      activeNum: "rong/activeNum",
      activeGroup: "rong/activeGroup",
      getUrl: "headurl/getUrl",
      getMember: "headurl/getMember"
    }),
    showHistory(item, index) {
      this.rong.currentPage = 1;
      // this.rong.day1 = "";
      // this.rong.day2 = "";
      this.activeGroup();
      this.activeNum(index);
      this.rong.nomessage = false;
      this.initNum();
      this.getrecvID(item.recvId);
      this.getType(item.recvType);

      let startTime = 0;
      let endTime = new Date().getTime();
      if (this.rong.day1 != "") {
        startTime = this.rong.day1;
      }
      if (this.rong.day2 != "") {
        endTime = this.rong.day2;
      }

      let params = {
        userId: this.login.userInfo.itcode,
        recvId: item.recvId,
        currIndex: "",
        pageSize: "",
        startTime: startTime,
        endTime: endTime
      };
      // console.log(item)
      this.showHistory_s_r(params);
    },
    groupHistory(item, index) {
      this.rong.currentPage = 1;
      // this.rong.day1 = "";
      // this.rong.day2 = "";
      let content = document.getElementById("historycontent");
      content.scrollTop = content.scrollHeight;
      // console.log(item.recvId)
      this.getMember(item.recvId);
      // console.log(this.headurl.groupmember)
      this.getUrl(this.headurl.groupmember);

      this.activeNum();

      this.activeGroup(index);
      this.rong.nomessage = false;
      this.initNum();
      this.getrecvID(item.recvId);
      this.getType(item.recvType);
      let startTime = 0;
      let endTime = new Date().getTime();
      if (this.rong.day1 != "") {
        startTime = this.rong.day1;
      }
      if (this.rong.day2 != "") {
        endTime = this.rong.day2;
      }

      let params = {
        userId: this.login.userInfo.itcode,
        recvId: item.recvId,
        currIndex: "",
        pageSize: "",
        startTime: startTime,
        endTime: endTime
      };
      this.showHistory_g_r(params);
    },
    //搜索某个人或群
    searchList(e) {
      if (e.target.value == "") {
        this.searchShow = false;
        return;
      }
      this.showSearchList(e.target.value);

      this.searchShow = true;
    },
    closeSearch(){
      this.searchShow = false;
      document.getElementById('searchinput').value = ''
    },
    //某个人的记录
    searchperson(item) {
      this.showHistory(item);
    },
    //某个群的记录
    searchgroup(item) {
      this.groupHistory(item);
    },

    //查看所有人
    allsingle(params) {
      this.singleLength = params;
      // this.turn = true;
    },
    //查看所有群
    allgroup(params) {
      this.groupLength = params;
    },
    //点击单聊伸缩
    singleSHOW() {
      this.turn = true;
      if (!this.singleshow) {
        this.turn = false;
        this.singleLength = 5; //还原初始5个
      }
      this.singleshow = !this.singleshow;
    },
    //点击群聊伸缩
    groupSHOW() {
      this.groupturn = true;
      if (!this.groupshow) {
        this.groupturn = false;
        this.groupLength = 5; //还原初始5个
      }
      this.groupshow = !this.groupshow;
    },
    //收起全部
    allclose() {
      this.singleLength = 5;
    },
    closegroup() {
      this.groupLength = 5;
    }
  },

  mounted() {
    this.rong.activeIndex = null;
    this.rong.activeGroupIndex = null;
    //获取登陆人的好友列表
    let params = {
      sessionId: this.login.userInfo.session_id,
      userId: this.login.userInfo.itcode
    };
    this.getList(params);

    // console.log(this.personalList)
    // //获取单人itcode列表
    // let singleUrlList = this.personalList.map(item => {
    //   return item.recvId;
    // });
    // this.getSingleHeadUrl(singleUrlList)

    // //获取群itcode列表
    // let groupUrlList = this.groupList.map(item => {
    //   return item.recvId
    // })
    // this.getGroupHeadUrl(groupUrlList)

    // console.log(this.rong.singleHeadUrl,this.rong.groupHeadUrl)
  }
};
</script>

<style lang="scss" scoped>
.personlist-main {
  // width: 400px;
  padding-left: 50px;
  height: 550px;
  border-right: 1px solid #e0e1e1;
  .turn {
    transform: rotate(-90deg);
  }
  .search {
    .searchicon {
      width: 12px;
      height: 13px;
      position: relative;
      left: 25px;
      top: 1px;
    }
    .close {
      width: 12px;
      height: 13px;
      position: relative;
      left: -25px;
      top: 1px;
      cursor: pointer;
    }
    input {
      font-size: 14px;
      font-family: PingFangSC;
      color: rgba(178, 178, 178, 1);
      padding-left: 25px;
      // text-align: center;
      outline: none;
      border: none;
      width: 207px;
      height: 37px;
      // line-height: 37px;
      background: rgba(243, 246, 248, 1);
      border-radius: 4px;
      border: 1px solid rgba(227, 227, 228, 1);
    }
  }
  .search-box {
    padding-top: 10px;
    height: 480px;
    overflow-y: auto;
    width: 255px;
    li {
      cursor: pointer;
      // width: 253px;
      padding: 5px 0 6px 20px;
      font-size: 13px;
      font-family: PingFangSC;
      color: rgba(74, 74, 74, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 50px;
    }
    li:hover {
      background: rgba(37, 182, 237, 0.08);
    }
  }
  .search-box::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    // scrollbar-arrow-color:red;
  }
  .search-box::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .active {
    background: rgba(37, 182, 237, 0.08);
    border-right: 3px solid rgba(37, 182, 237, 1);
  }
  .list {
    padding-top: 35px;
    height: 520px;
    overflow-y: auto;
    width: 255px;
    // border-right:1px solid black;
    // padding-left: 30px;
    .chatimg {
      width: 13px;
      height: 13px;
      margin-right: 14px;
    }
    .downimg {
      width: 10px;
      height: 6px;
      margin-left: 15px;
      // transform:rotate(-90deg);
    }
    .chat-title {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      padding-left: 30px;
    }
    .single-chat {
      font-size: 14px;
      font-family: PingFangSC;
      color: rgba(0, 0, 0, 1);

      li:hover {
        background: rgba(37, 182, 237, 0.08);
      }
      .personalli {
        // width: 253px;
        cursor: pointer;
        padding: 5px 0 6px 20px;
        font-size: 13px;
        font-family: PingFangSC;
        color: rgba(74, 74, 74, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 50px;
      }
      .singleALL {
        cursor: pointer;
        display: inline-block;
        margin-top: 17px;
        margin-bottom: 40px;
        font-size: 13px;
        font-family: PingFangSC;
        color: rgba(37, 182, 237, 1);
        padding-left: 50px;
      }
    }
    .group-chat {
      font-size: 14px;
      font-family: PingFangSC;
      color: rgba(0, 0, 0, 1);
      li:hover {
        background: rgba(137, 190, 211, 0.08);
      }
      .groupli {
        cursor: pointer;
        // width: 253px;
        padding: 5px 0 6px 20px;
        font-size: 13px;
        font-family: PingFangSC;
        color: rgba(74, 74, 74, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 50px;
      }
      .groupALL {
        cursor: pointer;
        display: inline-block;
        margin-top: 17px;
        // margin-bottom:40px;
        font-size: 13px;
        font-family: PingFangSC;
        color: rgba(37, 182, 237, 1);
        padding-left: 50px;
      }
    }
  }
  .list::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    // scrollbar-arrow-color:red;
  }
  .list::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/rong/PersonList.vue